/**
 * MedCaddy API Client - Files Module
 * Handles file listing, upload, download, and deletion.
 */

import { apiFetch, assertOk, assertOkWithDetail } from './core';

// Files API
export const files = {
  async listForRecord(recordId) {
    const response = await apiFetch(`/files/record/${recordId}`);
    assertOk(response, 'Failed to fetch files');
    return response.json();
  },

  async upload(recordId, file) {
    const formData = new FormData();
    formData.append('file', file);

    const response = await apiFetch(`/files/upload/${recordId}`, {
      method: 'POST',
      body: formData
    });

    await assertOkWithDetail(response, 'Upload failed');
    return response.json();
  },

  async download(fileId) {
    const response = await apiFetch(`/files/${fileId}/download`);
    assertOk(response, 'Download failed');
    return response.blob();
  },

  async delete(fileId) {
    const response = await apiFetch(`/files/${fileId}`, {
      method: 'DELETE'
    });
    assertOk(response, 'Failed to delete file');
  }
};
